let kuji_win_ratio = '50';
const kuji_min_value = '50'; // $50

function setCookie(cname,cvalue,exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname+"="+cvalue+"; "+expires+"; path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function fadeIn(element,display) {
	var op = 0.1;  // initial opacity
	element.style.display = display;
	var timer = setInterval(function () {
		if (op >= 1){
			clearInterval(timer);
		}
		element.style.opacity = op;
		element.style.filter = 'alpha(opacity=' + op * 100 + ")";
		op += op * 0.1;
	}, 10);
}

function fadeOut(element) {
	var op = 1;  // initial opacity
	var timer = setInterval(function () {
		if (op <= 0.1){
			clearInterval(timer);
			element.style.display = 'none';
		}
		element.style.opacity = op;
		element.style.filter = 'alpha(opacity=' + op * 100 + ")";
		op -= op * 0.1;
	}, 10);
}

function closekuji(action,label) {
	current_popup = event.target.closest('.kuji-popup');
	fadeOut(current_popup)
}

function closekujiHIWExternal(e) {
	if(e.target !== e.currentTarget) return;
	fadeOut(kujiHIWPopup);
}

const
	KujiAssetUrl = 'https://cdn.shopify.com/s/files/1/0728/0410/6425/files/',
	RafAssetUrl = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/',
	kujiPopup = document.createElement("div"),
	kujiHIWPopup = document.createElement("div"),
	kujiIntroPopup = document.createElement("div");

var kuji_terms = 'Store credit code cannot be used in conjunction with any other offer, including bundle purchases'

let
	kujiPopupInit = false;

const
	RafLogo = `
	<img
	     loading="lazy"
	     width="200"
	     height="51"
	     src="`+RafAssetUrl+`kuji_logo_200x.png"
	     alt="kuji logo"/>
	`,

	RafGeneralInfo = `
	<p class="explain">Look out for the `+RafLogo+` button while shopping</p>
	`
;

function buildkujiPopup(merchant_cart,ticket_price,cart_total,ticket_url,cart_min){
	if ( kujiPopupInit == false ) {
		kujiPopup.setAttribute("id","kuji-popup");
		kujiPopup.setAttribute("class","kuji-popup");
	} else {
		kujiPopup.innerHTML = "";
	}

	m_cart = merchant_cart
	let credit = ticket_price * m_cart.multiple
	//TO DO - get this from merchant cart data

	if ( ticket_price < 30 ) {
		credit = credit.toFixed(2)
	}

	let merchant_name = m_cart.merchant.replaceAll(' ','-').toLowerCase();
	let feature_img = RafAssetUrl+`kuji-ticket-popup-card_800x.gif`;
		feature_img = RafAssetUrl+`merchant-`+merchant_name+`-card_800x.jpg`;

	let feature_text = `
			<div class="kuji-popup-content">
				<div class="kuji-relative">
					<div class="kuji-blur"></div>
					<h5><b>WIN Your Cart</b> for $`+ticket_price+`</h5>
				</div>
			</div>
		`;

	kujiPopup.innerHTML = `
	<div class="kuji-popup-inner">
		<button type="button" class="close-kuji-popup-x" onclick="closekuji('Close Popup','X')"></button>
		<div id="kuji-popup-content" class="popup-content">
			<div class="kuji-feature-img">
				<img class="kuji-popup-feature-img" src="`+feature_img+`">
				`+feature_text+`
			</div>
			<div class="kuji-prizes">
				<div class="prize prize-1">
					<h5>Your `+Shopify.formatMoney(cart_total, '${{amount}}')+` Cart</h5>
					<p>1 in `+m_cart.ratio+` win</p>
				</div>
				<span class="or">or</span/>
				<div class="prize prize-2">
					<h5>$`+credit+` OFF</h5>
					<p>at checkout</p>
				</div>
			</div>
			<div class="kuji-popup-card">
				<p>or get a $`+credit+` discount</p>
				<a id="kuji-buy-ticket" class="kuji-btn" href="`+ticket_url+`" target="_blank">
					Checkout
				</a>
			</div>

			<p class="kuji-prize-explain">
				<b>1 IN `+m_cart.ratio+` WIN THE `+Shopify.formatMoney(cart_total, '${{amount}}')+` CART.</b></br>
				kuji discount codes automatically apply to your cart at checkout and cannot be used in conjunction with any other discounts.
			</p>

			<div class="kuji-footer">
				<a class="kuji-footer-logo" href="https://www.kujinow.com" target="_blank" rel="noopener">`
				+RafLogo+`
				</a>
				<div class="kuji-footer-tcs">
					<p class="initial-tc">
						Your minimum cart spend is $`+cart_min+`.<br/>
						For kuji full <a href="https://kujinow.com/pages/terms-conditions" target=_"blank">T&C’s</a> and <a href="https://kujinow.com/pages/faqs" target=_"blank">FAQ’s</a>
					</p>
					<p class="hide-mobile">
						The minimum spend for your store credit must be equal to or greater than the value of the original cart. `+kuji_terms+`. The store credit is comprised of your $<span id="tc-ticket"></span> ticket and a $<span id="tc-bonus"></span> bonus store credit. The bonus store credit will have a validity of 14 days from the time of purchase.<br/>
						For kuji full <a href="https://kujinow.com/pages/terms-conditions" target=_"blank">T&C’s</a>, <a href="https://kujinow.com/pages/faqs" target=_"blank">FAQs</a> and  <a href="http://tinyurl.com/ybp2v5rb" target=_"blank">Reviews</a>
					</p>
				</div>
				<button type="button" class="kuji-more-info plain-text" onclick="openkujiInfo('Open Info','Popup')">Learn more<span class="kuji-chevron"></span></button>
				<button type="button" class="kuji-close-text plain-text" onclick="openkujiHIW('Popup','How It Works')">How It Works<span class="kuji-chevron down"></span></button>
			</div>
			<p class="kuji-footer-tcs show-mobile kuji-min-spend-tc">
				Your minimum cart spend is $`+cart_min+`>.
			<p class="kuji-footer-tcs show-mobile">
				For kuji full <a href="https://kujinow.com/pages/terms-conditions" target=_"blank">T&C’s</a>, <a href="https://kujinow.com/pages/faqs" target=_"blank">FAQs</a> and  <a href="http://tinyurl.com/ybp2v5rb" target=_"blank">Reviews</a>
			</p>
		</div>
	</div>
	`;

	kujiPopupInit = true;
	document.body.appendChild(kujiPopup);

	fadeIn(kujiPopup,'flex');
	//Lets not do this - too easy to close
	//kujiPopup.addEventListener("click", closekujiExternal);
}

function openkujiHIW(action,label) {
	kujiHIWPopup.setAttribute("id","kuji-hiw-popup");
	kujiHIWPopup.setAttribute("class","kuji-popup");

	kujiHIWPopup.innerHTML = `
	<div class="kuji-popup-inner">
		<button type="button" class="close-kuji-popup-x" onclick="closekuji('Close Popup','X')"></button>
		<div class="popup-content">
			<div class="hiw-content-wrapper">
				<div class="hiw-content">
					<h3>How it works?</h3>
					<h3 class="second-title">Win your cart.</h3>
					<table>
						<tbody>
						<tr>
							<td>
								<span class="step">STEP 1</span>
							</td>
							<td>
								<p>Add items to your cart and select the <strong>WIN IT NOW</strong> button</p>
							</td>
						</tr><tr>
							<td>
								<span class="step" style="background: #9948ff;">STEP 2</span>
							</td>
							<td>
								<p>Purchase a kuji Ticket</p>
							</td>
						</tr><tr>
							<td>
								<span class="step">STEP 3</span>
							</td>
							<td>
								<p><strong>GET</strong> your <strong>ENTIRE cart</strong> <em>OR</em> <strong>a multiple</strong> of the kuji ticket value in store credit</p>
							</td>
						</tr><tr>
							<td>
								<span class="step">STEP 4</span>
							</td>
							<td>
								<p>Finalise your purchase with your <strong>automatically applied</strong> kuji discount code</p>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="raf-hiw-img"> ;
					<img loading="lazy" width="968" height="1567" alt="kuji how it works" src="`+RafAssetUrl+`merchant_hiw_popup_800x.png">
				</div>
			</div>
		</div>
	</div>
	`;

	document.body.appendChild(kujiHIWPopup);
	kujiHIWPopup.addEventListener("click", closekujiHIWExternal);
	fadeIn(kujiHIWPopup,'flex');
}

if ( show_popup_1 ) {
	function openkujiIntroPopup(image) {
		kujiIntroPopup.setAttribute("id","kuji-intro-popup");
		kujiIntroPopup.setAttribute("class","kuji-popup");

		kujiIntroPopup.innerHTML = `
		<div class="kuji-popup-inner">
		<button type="button" class="close-kuji-popup-x" onclick="closekuji('Close Promo','X')"></button>
		<div class="popup-content">
		<img width="100px" height="100px" src="`+RafAssetUrl+`kuji-modal_800x.gif"
		</div>
		</div>
		`;

		document.body.appendChild(kujiIntroPopup);
		//kujiIntroPopup.addEventListener("click", closekujiPromoPopupExternal);
		fadeIn(kujiIntroPopup,'flex');

		setTimeout(function () {
			kujiIntroPopup.classList.add("active");
			setCookie("rafintro_viewed", 'true', 365);
		}, 1000);
	}

	if ( getCookie("rafintro_viewed") != "true") {

		setTimeout(function () {
			openkujiIntroPopup();
		}, 500);
	}
}
function kuji_redirect() {
	console.log('redirect')

	//TO DO: Need to update with our cart data
	const
	cart = json,
	kuji_checkout_btn = document.getElementById('kuji-buy-ticket');

	let cart_currency = getCookie("cart_currency");

	if ( cart_currency == "") {
		cart_currency = kuji_currency;
	}

	let url_geo = '';
	if ( cart_currency == "NZD") {
		url_geo = 'en-nz/'
	} else if ( cart_currency == "USD") {
		url_geo = 'en-us/'
	} else if ( cart_currency == "CAD") {
		url_geo = 'en-ca/'
	} else if ( cart_currency == "GBP") {
		url_geo = 'en-gb/'
	} else if ( cart_currency == "EUR") {
		url_geo = 'en-eu/'
	}

	const https_kuji = 'https://kujinow.com/'+url_geo+'cart?h=';

	let
		raf_cart_items = '',
		raf_cart_products = '';

	//Create Cart URL
	cart.items.forEach(function(item){
		console.log( item )
		raf_cart_items = raf_cart_items + item.variant_id + ':' + item.quantity + ',';
		raf_cart_products = raf_cart_products + item.title + ',';
	});

	//Fix product names for url
	raf_cart_products.replace('&','and').replace(',','');

	const kuji_url = https_kuji+Shopify.shop.replace('.myshopify.com','')+'&m='+kuji_merchant+'&t='+cart.total_price+'&x='+kuji_x+'&r='+kuji_win_ratio+'&i='+raf_cart_items+'&p='+raf_cart_products+'&s=r';

	if ( typeof(kuji_checkout_btn) != 'undefined' && kuji_checkout_btn != null ) {
		kuji_checkout_btn.setAttribute('href', kuji_url);
	}
}

function CustomCeil(number, digits) {
  var factor = Math.pow(10, digits);
  return Math.ceil(number*factor) / factor;
}

function openkuji(cart,merchant_handle,ticket_price,cart_total,ticket_url,cart_min) {
	cartIndex = cart.findIndex((obj => obj.handle == merchant_handle));

	buildkujiPopup(cart[cartIndex],ticket_price,cart_total,ticket_url,cart_min);
}


function calculate_ticket_price(r_ticket_price){
	let r_total = r_ticket_price / 10000.00;
	let r_min_cart = ''

	console.log( r_total )

	//Not used anymore
	//const r_ticket_decimal = parseFloat( ( r_total * 5 ).toFixed(1) );
	//console.log( r_ticket_price )
	//Divide cart by 20 or 40 depending on 1/30 or 1/60 win rates
	let WR = 20
	if (kuji_win_ratio == 60 || kuji_win_ratio == '60' || r_ticket_price > 50000) {
		WR = 40
	}

	console.log( WR )

	let r_ticket_decimal = r_ticket_price / (WR * 100.0) + 1;

	console.log( r_ticket_decimal )

	//CustomCeil rounds up to nearest 0.1 decimal
	r_ticket_decimal = CustomCeil(r_ticket_decimal,1)

	console.log( r_ticket_decimal )


	//console.log('decimal: '+ r_ticket_decimal )

	if ( r_ticket_price > kuji_min_value && r_ticket_decimal <= 9.99 ) {
		//$0-$198 = $0 - $9.90 tickets
		r_ticket = r_ticket_decimal; // round to nearest 10c
		r_min_cart = (r_ticket * WR) - (WR / 10); // Maybe this should be more to give leway?
	} else if ( r_ticket_decimal > 9.99 && r_ticket_decimal <= 30 ) {
		//$200-$600 = $10 - $30 tickets
		r_ticket = Math.ceil(r_ticket_decimal*2)/2; // round to nearest 50c
		r_min_cart = (r_ticket * WR) - (WR / 2);
	} else if ( r_ticket_decimal > 30 && r_ticket_decimal <= 99 ) {
		//$601-$1,980 = $31 - $99 tickets
		r_ticket = Math.ceil( r_ticket_decimal ); // round to nearest 1
		r_min_cart = (r_ticket * WR) - WR;
	} else if ( r_ticket_decimal > 99 && r_ticket_decimal <= 500 ) {
		//$2,000-$10,000 = $100 - $500 tickets
		r_ticket =  5 * Math.ceil(r_ticket_decimal / 5); // round to nearest 5
		r_min_cart = (r_ticket * WR) - ( WR * 5 );
	} else {

		/*} else if ( r_ticket_price > 198000 && r_ticket_price <= 1000000 ) {*/

		//Default shouldn't be used
		//r_ticket =  10 * Math.ceil(r_ticket_decimal / 10); // round to nearest 10
		//r_min_cart = (r_ticket * 20) - 10;
	}

	if ( r_ticket_price <= 300000 ) {
		kuji_widgets_enabled = true;
		return [r_ticket, r_min_cart];
	} else {
		kuji_widgets_enabled = false;
		//alert('kuji is only available on carts less than $3,000')
	}

}




const brandsSearchInput = document.getElementById('brands-search-input');
const brandsResultsList = document.getElementById('brands-search-results');
let debounceTimer;

if (brandsSearchInput){
	brandsSearchInput.addEventListener('input', function () {
		clearTimeout(debounceTimer);
		const query = brandsSearchInput.value.trim();

		if (query.length === 0) {
			brandsResultsList.innerHTML = '';
			return;
		}

		debounceTimer = setTimeout(() => {
			const tag = "kuji Retail Brand";
			const fullQuery = `${query}`;
			const encoded = encodeURIComponent(fullQuery);

			console.log(`/search/suggest.json?q=${encoded}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title`)

			fetch(`/search/suggest.json?q=${encoded}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title`)
				.then(res => res.json())
				.then(data => {
					console.log('searched');
					const products = data.resources.results.products;

					const filtered = data.resources.results.products.filter(
						p => p.type === "Merchant"
					);

					console.log(filtered);

					brandsResultsList.innerHTML = filtered.map(product => {

						// Extract tag values
						let multiple = '2';
						let merchant_type = 'retail';

						product.tags.forEach(tag => {
							if (tag.startsWith('multiple:')) {
								multiple = tag.split(':')[1].trim();
							}
							if (tag.startsWith('ratio:')) {
								ratio = tag.split(':')[1].trim();
							}
							if (tag == 'instore') {
								merchant_type = 'instore';
							}
						});

						/*
						return `
							<li data-kuji_x="${multiple}" data-merchant_type="${merchant_type}" data-title="${product.title}" data-merchant_handle="${product.handle}">
								${product.title}
							</li>
						`;*/


						return `
							<li>
								<a href="${product.url}" data-kuji_x="${multiple}" data-merchant_type="${merchant_type}data-title="${product.title}" data-merchant_handle="${product.handle}" >
									${product.title}
								</a>
							</li>
						`;

					}).join('');

					brandsResultsList.style.display = "block";
				})
				.catch(err => {
					console.error('Search error:', err);
				});
		}, 200); // debounce
	});

	let
		kuji_x = '',
		kuji_win_ratio = '',
		kuji_merchant = '',
		merchant_handle = '';

	document.getElementById('brands-search-results').addEventListener('click', function (e) {
		const li = e.target.closest('li[data-title]');
		if (!li) return;

		kuji_merchant = li.getAttribute('data-title');

		const input = document.getElementById('brands-search-input');
		const results = document.getElementById('brands-search-results');

		kuji_x = li.dataset.kuji_x,
		kuji_win_ratio = '50',
		merchant_handle = li.dataset.merchant_handle;
		merchant_type = li.dataset.merchant_type;

		document.getElementById('brands-selected-title').innerHTML = kuji_merchant;
		input.value = kuji_merchant;
		results.innerHTML = ''; // Clear the list
		results.style.display = 'none'; // Optional: hide the container

		let discountPercent = `${ kuji_x * 5}%`;

		if (kuji_x.includes('%')) {
			discountPercent = '10%-30%';
		}
		if ((kuji_x == '22.5%') || (kuji_x == '25%')) {
			discountPercent = '20%-50%';
		}

		document.getElementById('brands-discount-percent').innerHTML = discountPercent;

		document.getElementById('brands-popup-feature').src = `https://raflinappfiles.com/merchant-${merchant_handle}-card.png`

		const brandsPopupFeature = document.getElementById('brands-popup-feature');
		const brandsPopupFeatureSrc = `https://raflinappfiles.com/merchant-${merchant_handle}-card.webp`;
		const brandsPopupFeatureFallback = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/merchant-kuji-card_800x.jpg';

		brandsPopupFeature.onerror = function () {
			brandsPopupFeature.onerror = null; // prevent infinite loop if fallback also fails
			brandsPopupFeature.src = brandsPopupFeatureFallback;
		};
		brandsPopupFeature.src = brandsPopupFeatureSrc;

		const brandsMerchantLogo = document.getElementById('brands-merchant-logo');
		const brandsMerchantLogoSrc = `https://raflinappfiles.com/merchant-${merchant_handle}-icon.webp`;
		const brandsMerchantLogoFallback = 'https://cdn.shopify.com/s/files/1/0650/2019/9164/files/merchant-kuji-icon_60x.png?v=1668548689';

		brandsMerchantLogo.onerror = function () {
			brandsMerchantLogo.onerror = null; // prevent infinite loop if fallback also fails
			brandsMerchantLogo.src = brandsMerchantLogoFallback;
		};
		brandsMerchantLogo.src = brandsMerchantLogoSrc;

		const brandsPopup = document.getElementById('brands-popup');

		brandsPopup.style.display = 'flex';
		brandsPopup.style.opacity = '1';

		brandsCheckoutBtn.classList.add('disabled');

	});
}

const brandsCheckoutBtn = document.getElementById('brands-checkout-btn');
const brandsGetItNowPlaceholder = document.getElementById('brands-btn-placeholder');
const brandsGetItNowText = document.getElementById('brands-btn-text');

const brandsCartValue = document.getElementById('brands-cart-value');
if (brandsCartValue) {
	brandsCartValue.addEventListener('input', function (e) {
		const cartValue = parseFloat(e.target.value);
		const discount_multiple = e.target.dataset.discount_multiple;
		const discount_class = e.target.dataset.discount_class;
		const merchant_handle = e.target.dataset.merchant_handle;
		const merchant_name = e.target.dataset.merchant_name;

		console.log('discount_class',discount_class);

		const brandsTicketValue = document.getElementById('brands-ticket-value');

		if (!isNaN(cartValue)) {

			const ticketValueCalc = calculate_ticket_price(cartValue * 100);
			let ticketValue = ticketValueCalc[0] * 1;

			//Add double decimals for small tickets
			if ( ticketValue < 30 ) {
				ticketValue = ticketValue.toFixed(2)
			}

			brandsTicketValue.innerHTML = `${ticketValue}`;

			brandsGetItNowPlaceholder.style.display = 'none';
			brandsGetItNowText.style.display = 'block';

			const discount_multiple_url = discount_multiple.replace('%','');

			const brands_checkout_url = `https://kuji-app.myshopify.com/cart?h=${merchant_handle}&m=${merchant_name}&t=${cartValue * 100}&x=${discount_multiple_url}&r=${kuji_win_ratio}&s=r&c=${discount_class}`;

			brandsCheckoutBtn.setAttribute('href', brands_checkout_url);
			brandsCheckoutBtn.classList.remove('disabled');

		} else {
			brandsTicketValue.innerHTML = '0.00';

			brandsGetItNowPlaceholder.style.display = 'block';
			brandsGetItNowText.style.display = 'none';

			brandsCheckoutBtn.classList.add('disabled');

		}
	});
}